import { createContext, useContext, useState } from "react";

const GlobalIsReadContext=createContext()

export const GlobalIsReadProvider=({children})=>{
    const [isReaded,setIsReaded]=useState(false)
    return(
        <GlobalIsReadContext.Provider value={{isReaded,setIsReaded}}>
            {children}
            
        </GlobalIsReadContext.Provider>
    )
}

export const useIsReadContext=()=>useContext(GlobalIsReadContext)